import { useEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
export function useResizeObserver(ref, onResize) {
    var observable = ref.current;
    useEffect(function () {
        if (!ref.current) {
            return;
        }
        var observer = new ResizeObserver(function (entries, ob) {
            return requestAnimationFrame(function () { return onResize(entries, ob); });
        });
        observer.observe(ref.current);
        return function () { return observer.disconnect(); };
    }, [onResize, observable, ref]);
}
//# sourceMappingURL=useResizeObserver.js.map